import { Validator } from '@vista-digital/validator';
import { formEventsValidatorSchema } from '../../../../subcomponents/form/form/types/events';
export const memberPasswordResetFormEventsValidator = Validator.object(Object.assign(Object.assign({}, formEventsValidatorSchema), { onPasswordResetMessageActionButtonClick: Validator.optional(Validator.fn()) }));
